import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Tesorería y ventas",
    items: [
      { label: "Bancos",        icon: "fas fa-university",          href: "/Bancos",        perm: "menu_admin" },
      { label: "Ventas",        icon: "fas fa-money-bill-wave",     href: "/ListadoVentas", perm: "menu_admin" },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", href: "/EstadoCuenta",  perm: "menu_admin" },
      { label: "Antigüedad Saldos", icon: "fas fa-hourglass-half", href: "/AntiguedadSaldos", perm: "menu_admin" },
      { label: "Abonos",        icon: "fas fa-dollar-sign",         href: "/ListadoAbonos", perm: "menu_admin" },
      { label: "Comisiones",    icon: "fas fa-hand-holding-usd",    href: "/ListadoComisiones", perm: "menu_admin" },
      { label: "Edo. Cta. Vendedores", icon: "fas fa-user-tie",     href: "/EstadoCuentaColaboradores", perm: "menu_admin" },
    ],
  },
  {
    title: "Documentos",
    items: [
      { label: "Notas de Cargo", icon: "fas fa-money-check-alt", href: "/ListadoNotasCargo",        perm: "menu_admin" },
      { label: "Devoluciones",   icon: "fas fa-undo-alt",        href: "/ListadoDevolucionesAdmin", perm: "menu_admin" },
    ],
  },
  {
    title: "Catálogos",
    items: [
      { label: "Conceptos Bonificaciones", icon: "fas fa-bars",         href: "/ListadoConceptosBonificaciones", perm: "menu_admin" },
      { label: "Bonificaciones",           icon: "fas fa-search-dollar", href: "/ListadoBonificaciones",         perm: "menu_admin" },
      { label: "Empresas",                 icon: "fas fa-industry",      href: "/ListadoEmpresas",               perm: "menu_admin" },
    ],
  },
];

function BotonesAdmin() {
  return (
    <MenuGrid
      title="Admin"
      subtitle="Tesorería, ventas, estados de cuenta y catálogos"
      icon="fas fa-file-invoice-dollar"
      accent={{ color: "#10b981", bg: "#f0fdf4" }}
      gate="menu_admin"
      sections={SECTIONS}
    />
  );
}

export default BotonesAdmin;
